import React from "react"

class DownloadEditor extends React.Component{
    downloadEditor = () =>{
        window.open(`/download/dreameditor/release/latest`, "_self")
    }
    render(){
        return(
            <div className="mainContent">
                <div className="downloadEditor">
                    <h1>Get the editor to start creating games!</h1>
                    <button className="downloadBtn" onClick={this.downloadEditor}>
                        Download!
                    </button>
                </div>
            </div>
        )
    }
}

export default DownloadEditor